import { treeToAST } from "./transformer";
function writeExprReferenceProps(props, state) {
    if (!props) {
        return;
    }
    if (props.parent) {
        writeExprReferenceProps(props.parent, state);
        state.write(".");
        // state.write(name.parent?.optional ? "?." : ".");
        state.write(props.name);
    }
    else {
        state.write(props.name);
    }
}
var State = /** @class */ (function () {
    function State() {
        Object.defineProperty(this, "output", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.output = "";
    }
    Object.defineProperty(State.prototype, "write", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (code) {
            this.output += code;
        }
    });
    Object.defineProperty(State.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.output;
        }
    });
    return State;
}());
/* eslint-disable @typescript-eslint/naming-convention */
var generators = {
    Program: function (node, state) {
        for (var i = 0; i < node.statements.length; i++) {
            var expr = node.statements[i];
            generators[expr.kind](expr, state);
        }
    },
    LiteralExpr: function (node, state) {
        state.write("" + node.text);
    },
    ParenExpr: function (node, state) {
        state.write("(");
        generators[node.expr.kind](node.expr, state);
        state.write(")");
    },
    ArrayLiteralExpr: function (node, state) {
        state.write("[");
        if (node.values.length > 0) {
            var values = node.values;
            var length_1 = values.length;
            for (var i = 0;;) {
                var value = values[i];
                if (value) {
                    generators[value.kind](value, state);
                }
                if (++i < length_1) {
                    state.write(", ");
                }
                else {
                    if (!value) {
                        state.write(", ");
                    }
                    break;
                }
            }
        }
        state.write("]");
    },
    ObjectLiteralExpr: function (node, state) {
        state.write("{");
        if (node.properties.length > 0) {
            var properties = node.properties;
            var length_2 = properties.length;
            for (var i = 0;;) {
                var property = properties[i];
                state.write(property.key + ": ");
                generators[property.value.kind](property.value, state);
                if (++i < length_2) {
                    state.write(", ");
                }
                else {
                    break;
                }
            }
        }
        state.write("}");
    },
    TernaryExpr: function (node, state) {
        generators[node.expr.kind](node.expr, state);
        state.write("?");
        generators[node.fullfil.kind](node.fullfil, state);
        state.write(":");
        generators[node.otherwise.kind](node.otherwise, state);
    },
    CallableExprReference: function (node, state) {
        state.write(node.name);
    },
    ExprReference: function (node, state) {
        state.write("get(");
        state.write(node.ref.name);
        if (node.ref.props) {
            state.write(", '");
            writeExprReferenceProps(node.ref.props, state);
            state.write("'");
        }
        state.write(")");
    },
    CallExpr: function (node, state) {
        generators[node.expr.kind](node.expr, state);
        state.write("(");
        var funcArguments = node.funcArguments;
        var length = funcArguments.length;
        for (var i = 0;;) {
            var arg = funcArguments[i];
            if (arg) {
                generators[arg.kind](arg, state);
            }
            if (++i < length) {
                state.write(", ");
            }
            else {
                if (!arg) {
                    state.write(", ");
                }
                break;
            }
        }
        state.write(")");
    },
};
/* eslint-enable */
export function generate(node) {
    var state = new State();
    var generator = generators[node.kind];
    if (generator) {
        generator(node, state);
    }
    return state.output;
}
export function generateFromTree(tree) {
    return generate(treeToAST(tree));
}
